export default __webpack_public_path__ + "static/media/penguin.c95dbd23.png";